import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _parseFloat from "@babel/runtime-corejs3/core-js/parse-float";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ApplicationCardHeader from "@Broker/@Modules/util-components/application-card-header";
import InlinePrompt from "@Shared/components/general/inline-prompt";
import * as FieldComponents from "@Shared/components/sections/index";
import DuplicatorMixin from "@Shared/utils/application-mixins/duplicator-mixin";
import VisibilityToggleMixin from "@Shared/utils/application-mixins/visibility-toggle-mixin";
import PropertyMixin from "@Broker/@Modules/clients/applications/application/select-options/property-mixin";
import MortgageDetailsMixin from "@Broker/@Modules/clients/applications/application/select-options/mortgage-details-mixin";
import { ADD_APPLICATION_GROUP, REMOVE_APPLICATION_GROUP, REPLICATE_APPLICATION_GROUP } from "../../../store/application-actions";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { createHelpers } from "@joandvgv/vuex-map-fields";
import { isEmpty, kebabCase, mapValues } from "lodash";
import { DELETE_ALL_PROPERTY_EXISTING_MORTGAGES, SET_APPLICATION_WITH_DEFAULTS_FOR_PAGE } from "../../../store/application-mutations";
import { PagesVisibilityMap } from "@Broker/@Utils/application/pages-visibility-map.ts";
import MultipleVisibilityButton from "@Broker/@Modules/clients/applications/application/components/pages-components/application/util-components/multiple-visibility-button.vue";
const {
  mapFields,
  mapMultiRowFields
} = createHelpers({
  getterType: "getDetails",
  mutationType: "setDetails"
});
const root = "property";
const details = `${root}[details]`;
const costs = `${root}[costs]`;
const styles = `${root}[styles]`;
const paths = {
  address: details,
  livingSpace: details,
  purchaseDate: details,
  propertyValueIndex: details,
  propertyStyle: styles,
  propertyType: styles,
  garageSize: styles,
  constructionType: styles,
  structureAge: styles,
  garageStyle: styles,
  numberOfUnits: styles,
  tenure: styles,
  lotSize: styles,
  lotSizeType: styles,
  heat: styles,
  waterInfo: styles,
  environmentalHazard: styles,
  sewageInfo: styles,
  propertyTaxes: costs,
  taxYear: costs,
  taxResponsible: costs,
  rentalIncomeOptions: costs,
  rentalIncomeOptionsPercent: costs,
  percOfTotalMaintFees: costs,
  maintenanceFees: costs,
  feesIncludeHeat: costs,
  heating: costs,
  hydro: costs,
  management: costs,
  repairs: costs,
  interest: costs,
  insurance: costs,
  others: costs,
  occupancy: details,
  rentalProperty: details,
  monthlyIncome: details,
  mlsListing: details,
  lot: details,
  block: details,
  concTownship: details,
  purchasePrice: details,
  estimatedValue: details,
  appraisedValue: details,
  appraisalDate: details,
  existingMortgages: root,
  includeInTds: costs
};
import { defineComponent } from "@vue/composition-api";
import { CO_BROKERED_MORTGAGES } from "../../../store/application-getters";
export default defineComponent({
  name: "Property",
  components: _objectSpread(_objectSpread({}, FieldComponents), {}, {
    InlinePrompt,
    ApplicationCardHeader,
    MultipleVisibilityButton
  }),
  mixins: [DuplicatorMixin, VisibilityToggleMixin, PropertyMixin, MortgageDetailsMixin],
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    currentApplication: {
      type: Object,
      default: () => ({})
    },
    editVisibility: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const checkRentalType = ocup => {
      var _context;
      return _includesInstanceProperty(_context = ["owner-occupied-and-rental", "rental"]).call(_context, ocup);
    };
    let isRentalType = checkRentalType(this.occupancy);
    return {
      checkRentalType,
      isRentalType,
      PagesVisibilityMap
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    visibilityPaths() {
      return mapValues(paths, (path, key) => `${path}[${kebabCase(key)}]`);
    }
  }, mapFields("ApplicationStore", {
    includeInTds: () => paths.includeInTds,
    address: () => paths.address,
    livingSpace: () => paths.livingSpace,
    propertyValueIndex: () => paths.propertyValueIndex,
    propertyStyle: () => paths.propertyStyle,
    purchaseDate: () => paths.purchaseDate,
    propertyType: () => paths.propertyType,
    garageSize: () => paths.garageSize,
    constructionType: () => paths.constructionType,
    structureAge: () => paths.structureAge,
    garageStyle: () => paths.garageStyle,
    numberOfUnits: () => paths.numberOfUnits,
    tenure: () => paths.tenure,
    lotSize: () => paths.lotSizeType,
    lotSizeType: () => paths.lotSizeType,
    heat: () => paths.heat,
    waterInfo: () => paths.waterInfo,
    environmentalHazard: () => paths.environmentalHazard,
    sewageInfo: () => paths.sewageInfo,
    propertyTaxes: () => paths.propertyTaxes,
    taxYear: () => paths.taxYear,
    taxResponsible: () => paths.taxResponsible,
    rentalIncomeOptions: () => paths.rentalIncomeOptions,
    rentalIncomeOptionsPercent: () => paths.rentalIncomeOptions,
    percOfTotalMaintFees: () => paths.percOfTotalMaintFees,
    maintenanceFees: () => paths.maintenanceFees,
    feesIncludeHeat: () => paths.feesIncludeHeat,
    heating: () => paths.heating,
    hydro: () => paths.hydro,
    management: () => paths.management,
    repairs: () => paths.repairs,
    interest: () => paths.interest,
    insurance: () => paths.insurance,
    others: () => paths.others,
    occupancy: () => paths.occupancy,
    rentalProperty: () => paths.rentalProperty,
    monthlyIncome: () => paths.monthlyIncome,
    mlsListing: () => paths.mlsListing,
    lot: () => paths.lot,
    block: () => paths.block,
    concTownship: () => paths.concTownship,
    purchasePrice: () => paths.purchasePrice,
    estimatedValue: () => paths.estimatedValue,
    appraisedValue: () => paths.appraisedValue,
    appraisalDate: () => paths.appraisalDate
  })), mapMultiRowFields("ApplicationStore", {
    existingMortgages: () => "property"
  })), mapGetters("ApplicationStore", [CO_BROKERED_MORTGAGES])), {}, {
    allowForExistingMortgages() {
      const allowedFlows = ["refinance-approval", "switch-transfer"];
      const isAllowedFlow = _includesInstanceProperty(allowedFlows).call(allowedFlows, this.currentApplication.flow);
      const hasCoBrokeredMortgages = !isEmpty(this.CO_BROKERED_MORTGAGES);
      return isAllowedFlow || hasCoBrokeredMortgages;
    }
  }),
  watch: {
    occupancy(value) {
      this.isRentalType = this.checkRentalType(value);
      this.rentalProperty = this.isRentalType;
    }
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("ApplicationStore", [ADD_APPLICATION_GROUP, REMOVE_APPLICATION_GROUP, REPLICATE_APPLICATION_GROUP])), mapMutations("ApplicationStore", [SET_APPLICATION_WITH_DEFAULTS_FOR_PAGE, DELETE_ALL_PROPERTY_EXISTING_MORTGAGES])), {}, {
    handleVisibility(data) {
      this.$emit("toggle-visibility", data);
    },
    handleDuplicate({
      what,
      where
    }) {
      this.ADD_APPLICATION_GROUP({
        what,
        where
      });
      this.$emit("save");
    },
    handleRemove(index, removePath) {
      this.REMOVE_APPLICATION_GROUP({
        index,
        where: removePath
      });
      this.$emit("save");
    },
    handleReplicateAddress() {
      this.REPLICATE_APPLICATION_GROUP({
        path: "main-applicant[personal-details][addresses]",
        index: 0,
        targetPath: "property[details]",
        key: "address"
      });
      this.$emit("replicate");
    },
    handleSave() {
      this.$emit("save");
    },
    applyDefaultValuesOnMortgageTypeChange(mortgageType) {
      if (mortgageType) {
        this.SET_APPLICATION_WITH_DEFAULTS_FOR_PAGE({
          page: "property",
          triggerOnSave: true
        });
      }
    },
    handleDeleteAllExistingMortgages() {
      this.DELETE_ALL_PROPERTY_EXISTING_MORTGAGES();
      this.handleSave();
    },
    setDefaultPropertyValueIndex() {
      const purchasePrice = _parseFloat(this.purchasePrice);
      const appraisedValue = _parseFloat(this.appraisedValue);
      const estimatedValue = _parseFloat(this.estimatedValue);
      const allValues = ["purchasePrice", "appraisedValue", "estimatedValue"];
      const updated = allValues.some(currentValue => {
        const otherValues = _filterInstanceProperty(allValues).call(allValues, otherValue => otherValue !== currentValue);
        // Check if currentValue is the only one value filled out
        const isOnlyOneFilledOut = !!_parseFloat(this[currentValue]) && otherValues.every(value => !_parseFloat(this[value]));
        if (isOnlyOneFilledOut) {
          this.propertyValueIndex = currentValue.charAt(0).toUpperCase(); // Select the only value filled out
        }
        return isOnlyOneFilledOut;
      });
      if (updated) return;

      // Two values are filled out

      if (estimatedValue && purchasePrice && !appraisedValue) {
        this.propertyValueIndex = "P";
        return;
      }
      if (estimatedValue && appraisedValue && !purchasePrice) {
        this.propertyValueIndex = "A";
        return;
      }
      if (purchasePrice <= appraisedValue) this.propertyValueIndex = "P";else this.propertyValueIndex = "A";
    }
  })
});